export default __webpack_public_path__ + "static/media/education_4.c24078e0.png";